import i18n from "i18next";
import homepageEnglish from "./en/homepage.json";
import sessionEnglish from "./en/session.json";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

export type TranslationNamespaces = "homepage" | "session";

export const translationNamespaces: TranslationNamespaces[] = [
	"homepage",
	"session"
];

export interface HomepageNamespace {
	default: {
		language: string;
		registration: {
			"Register for the event": string;
			"Tell us about yourself": string;
			"Please enter a valid email address.": string;
			registration_fields: {
				[key: number]: string;
			}
		};
		["Not Found"]: string;
		Agenda: string;
	};
}
export interface SessionNamespace {
	default: {
		language: string;
		video: {
			"Add to Calendar": string;
		};
	};
}

export type ModuleNamespaces = HomepageNamespace | SessionNamespace | any;

export const resources = {
	// load in english as default
	en: {
		homepage: homepageEnglish,
		session: sessionEnglish
	}
	// All the other translations will be dynamically loaded when a user selects a different language
	// To create type definitions for namespaces, add them to src/react-i18next.d.ts
} as const;

i18n
	.use(Backend)
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		lng: "en",
		ns: translationNamespaces,
		resources,
		// debug: process.env.NODE_ENV === 'production' ? false : true,
		debug: false,
		detection: {
			order: ["queryString", "cookie"],
			cache: ["cookie"]
		},
		interpolation: {
			escapeValue: false
		}
	});
